export default {
  nav: {
    dashboard: 'Startseite',
    markets: 'Märkte',
    trade: 'Handeln',
    support: 'Support',
    profile: 'Profil'
  },
  trade: {
    title: 'Handel',
    spot: 'Spot',
    futures: 'Futures',
    copytrading: 'Copytrading',
    leaderboard: 'Rangliste',
    myTraders: 'Meine Trader',
    myTrades: 'Meine Trades',
    becomeTrader: 'Trader werden',
    buy: 'Kaufen',
    sell: 'Verkaufen',
    price: 'Preis',
    amount: 'Menge',
    total: 'Gesamt',
    available: 'Verfügbar',
    margin: 'Marge',
    leverage: 'Hebel',
    orderType: 'Ordertyp',
    limit: 'Limit',
    market: 'Markt',
    tpsl: 'TP/SL',
    openChart: 'Chart öffnen',
    selectToken: 'Token auswählen',
    positionsHistory: 'Positionsverlauf',
    copyingActiveTitle: 'Kopieren aktiv',
    copyingActiveMessage: 'Ihre Wallet ist mit Copytrading verbunden. Das Eröffnen von Trades auf Spot- und Futures-Märkten ist derzeit nicht verfügbar, da die Marge in aktiven Kopierpositionen verwendet wird.\n\nUm den Handel wiederherzustellen, trennen Sie sich vom Trader und stoppen Sie das Kopieren von Trades.',
    becomeTraderTitle: 'Trader werden',
    becomeTraderMessage: 'Um Copy-Trader zu werden und nicht nur mit eigenen Mitteln zu verdienen, müssen Sie den VIP-Kontostatus erhalten.\n\nDer VIP-Status eröffnet den Zugang zur Verbindung von Abonnenten, ermöglicht die Skalierung des Handels mit deren Kapital und den Erhalt zusätzlicher Belohnungen aus Gewinnen bei kopierten Trades.',
    cannotCopyTitle: 'Mehrere Trader können nicht kopiert werden',
    cannotCopyMessage: 'Sie können nicht mehrere Trader gleichzeitig kopieren, da Ihr Konto noch nicht den Platinum-Status erreicht hat.\n\nErhalten Sie den Platinum-Status — und schalten Sie die Möglichkeit frei, mehrere Trader zu kopieren und Strategien zu diversifizieren.',
    copying: 'Kopieren',
    copy: 'Kopieren',
    roi: 'ROI',
    pnl: 'PnL',
    drawdown: 'Drawdown',
    followers: 'Follower',
    ok: 'OK',
    close: 'Schließen'
  },
  maintenance: {
    title: 'Liebe Benutzer!',
    message1: 'Derzeit werden technische Arbeiten zur Optimierung und Verbesserung des Systems durchgeführt.',
    message2: 'Aus diesem Grund können einige Funktionen instabil arbeiten oder vorübergehende Einschränkungen aufweisen.',
    message3: 'Die Anwendung funktioniert weiterhin normal, der Zugriff auf die Hauptfunktionalität bleibt erhalten.',
    message4: 'Vielen Dank für Ihr Verständnis. Wir arbeiten daran, dass alles so schnell und stabil wie möglich funktioniert.',
    button: 'Verstanden'
  },
  settings: {
    title: 'Einstellungen',
    language: 'Sprache',
    theme: 'Design',
    support: 'Support',
    dark: 'Dunkel',
    light: 'Hell'
  },
  profile: {
    title: 'Profil',
    balance: 'Guthaben',
    withdraw: 'Abheben',
    totalBalance: 'Ihr gesamtes Vermögensguthaben',
    viewHistory: 'Transaktionsverlauf anzeigen',
    referrals: 'Empfehlungen',
    referralsCount: '{count} Empfehlungen',
    rewards: 'Belohnungen',
    rewardsCount: '{count} Belohnungen',
    rewardsMessage: 'Belohnungen werden automatisch auf Ihr Guthaben gutgeschrieben',
    yourCode: 'Ihr Code:',
    copy: 'Kopieren',
    copied: 'Kopiert!',
    pnl7d: '7D PnL',
    pnl30d: '30D PnL',
    pnl90d: '90D PnL',
    aum: 'AUM',
    roi: 'ROI',
    roi90d: 'ROI (90D)',
    unsubscribe: 'Abmelden',
    resume: 'Fortsetzen',
    resuming: 'Wird fortgesetzt...',
    inactiveTitle: 'Ihre Anfrage wurde erfolgreich angenommen!',
    inactiveMessage: 'Die Mittel werden innerhalb von 21 Tagen freigegeben — diese Zeit ist erforderlich, um alle Trades zu schließen, Gewinne zu berechnen und das Kopieren ordnungsgemäß abzuschließen. Dies geschieht zu Ihrer Sicherheit und zum Schutz des Kapitals. Wenn Sie das Kopieren dieses Traders fortsetzen möchten, klicken Sie auf die Schaltfläche "Fortsetzen".',
    inviteButton: 'Empfehlung einladen und gemeinsam kopieren!',
    referralLimitMessage: 'Es ist derzeit nicht möglich, neue Empfehlungen mit diesem Trader zu verbinden. Er hat eine Begrenzung der Anzahl der Benutzer festgelegt, die seine Trades kopieren dürfen',
    ok: 'Ok',
    vipTier: 'VIP-Stufe',
    yourProgress: 'Ihr Fortschritt',
    currentTier: 'Aktuelle Stufe',
    progressTooltip: 'Ihr Stufenfortschritt wächst, wenn Sie Ihre Handelsaktivität, Einzahlungsaktivität und das gesamte Handelsvolumen erhöhen.',
    currentExp: 'Aktuelles EXP:',
    expToNext: 'EXP bis zur nächsten Stufe:',
    maxLevel: 'Maximale Stufe erreicht!',
    unsubscribeConfirm: 'Kopieren der Trades des Traders beenden? Nach dem Deaktivieren erhalten Sie keine Gewinne mehr aus seinem Trading.',
    no: 'Nein',
    yes: 'Ja',
    processing: 'Wird verarbeitet...',
    withdrawFunds: 'Geld abheben',
    confirmWithdrawal: 'Abhebung bestätigen',
    enterPin: 'PIN-Code eingeben',
    pinDescription: 'Bitte geben Sie Ihren PIN-Code ein, um die Abhebung zu bestätigen',
    network: 'Netzwerk',
    selectNetwork: 'Netzwerk auswählen',
    walletAddress: 'Wallet-Adresse',
    enterWallet: 'Wallet-Adresse eingeben',
    amount: 'Betrag (USDT)',
    enterAmount: 'Betrag eingeben',
    available: 'Verfügbar:',
    minMax: 'Min: {min} USDT | Max: {max} USDT pro Transaktion',
    cancel: 'Abbrechen',
    continue: 'Weiter',
    confirm: 'Bestätigen',
    back: 'Zurück',
    withdrawalSubmitted: 'Abhebungsanfrage eingereicht',
    withdrawalMessage: 'Ihre Anfrage wird überprüft, danke fürs Warten',
    openPositionsErrorTitle: 'Lieber Benutzer!',
    openDashboard: 'Dashboard öffnen',
    openPositionsErrorMessage: 'Ihre Anfrage wurde nicht bearbeitet, da Ihr Konto offene Trades mit Cross-Margin hat.\nBitte schließen Sie alle aktiven Positionen und versuchen Sie es erneut.',
    transactionHistory: 'Transaktionsverlauf',
    loadingHistory: 'Verlauf wird geladen...',
    noTransactions: 'Noch keine Transaktionen',
    deposit: 'Einzahlung',
    withdrawal: 'Abhebung',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    completed: 'Abgeschlossen',
    declined: 'Abgelehnt',
    failed: 'Fehlgeschlagen',
    networkLabel: 'Netzwerk:',
    addressLabel: 'Adresse:',
    reasonLabel: 'Grund:',
    noReason: 'Kein Grund angegeben',
    na: 'N/A',
    levels: {
      bronze: {
        benefit1: 'Reguläre Handelsgebühren',
        benefit2: 'Standard-Abhebungslimits',
        benefit3: 'Monatliche Belohnungen',
        benefit4: 'Margin-Trading bis zu 3x Hebel'
      },
      silver: {
        benefit1: '5% niedrigere Handelsgebühren',
        benefit2: 'Monatliche Boni',
        benefit3: 'Margin-Trading bis zu 5x Hebel'
      },
      gold: {
        benefit1: '10% niedrigere Handelsgebühren',
        benefit2: 'Prioritärer Kundensupport',
        benefit3: 'Früher Zugang zu neuen Instrumenten',
        benefit4: 'Margin-Trading bis zu 10x Hebel'
      },
      platinum: {
        benefit1: '25% niedrigere Handelsgebühren',
        benefit2: 'Persönlicher Account-Manager',
        benefit3: 'Einladungen zu privaten Communities',
        benefit4: 'Margin-Trading bis zu 50x Hebel'
      },
      vip: {
        benefit1: 'Keine Handelsgebühren',
        benefit2: 'Vollständiger Zugang zum OTC-Desk',
        benefit3: 'VIP-Manager 24/7',
        benefit4: 'Individuelle Limits und Bedingungen',
        benefit5: 'Einladungen zu privaten Offline-Events',
        benefit6: 'Margin-Trading bis zu 100x'
      }
    }
  },
  faq: {
    title: 'FAQ / Support',
    footerText: 'Wenn Sie die Antwort auf Ihre Frage nicht gefunden haben, kontaktieren Sie gerne',
    customerSupport: 'den Kundensupport',
    footerEnd: "für weitere Unterstützung. Oder per E-Mail:",
    questions: {
      q1: 'Was ist Copy Trading?',
      q2: 'Wie beginne ich, einen Trader zu kopieren?',
      q3: 'Kann ich das Kopieren jederzeit beenden?',
      q4: 'Wer kontrolliert meine Mittel?',
      q6: 'Was passiert, wenn der Trader einen Verlust erleidet?',
      q7: 'Kann ich mehrere Trader gleichzeitig kopieren?',
      q8: 'Wie oft wird die Trader-Statistik aktualisiert?',
      q9: 'Wo kann ich meine Ergebnisse einsehen?',
      q10: 'Kann ein Trader seine Strategie ändern?',
      q11: 'Ist es sicher, Trades zu kopieren?'
    },
    answers: {
      a1: 'Copy Trading ist ein Mechanismus, der die Trades eines ausgewählten Traders automatisch in Echtzeit spiegelt.',
      a2: 'Wählen Sie einen Trader, klicken Sie auf "Verbinden" und bestätigen Sie den Betrag, den Sie für das Kopieren zuweisen möchten.',
      a3: 'Ja, Sie können das Kopieren jederzeit beenden und Positionen schließen, vorbehaltlich der Bedingungen des Traders.',
      a4: 'Ihre Mittel bleiben auf Ihrem persönlichen Wallet/Börsenkonto. Der Trader hat keinen Zugriff darauf.',
      a6: 'Verluste werden proportional zu Ihrem zugewiesenen Betrag verteilt. Der Trader übernimmt keine finanzielle Verantwortung für das Ergebnis.',
      a7: 'Ja, wenn Ihr Guthaben es zulässt. Dies kann helfen, das Risiko zu diversifizieren.',
      a8: 'Die Statistiken werden in Echtzeit oder mit minimaler Verzögerung aktualisiert.',
      a9: 'Im Bereich "Dashboard" oder "Profile" finden Sie detaillierte Informationen zu Gewinnen, Verlusten und aktiven Positionen.',
      a10: 'Ja, Trader können ihre Strategie jederzeit frei anpassen, und alle Änderungen werden automatisch in den kopierten Trades widergespiegelt.',
      a11: 'Die Sicherheit hängt vom Risikoniveau des von Ihnen gewählten Traders ab. Wir empfehlen, ROI, PnL und Risikokennzahlen vor dem Verbinden zu überprüfen.'
    }
  },
  markets: {
    title: 'Märkte',
    searchPlaceholder: 'Nach Name oder Symbol suchen',
    loadingMarkets: 'Märkte werden geladen…',
    unableToLoad: 'Märkte konnten nicht geladen werden',
    tryAgain: 'Erneut versuchen',
    nothingFound: 'Nichts gefunden',
    nothingFoundMessage: 'Versuchen Sie, Ihre Such- oder Sortieroptionen zu ändern.',
    loading: 'Wird geladen...',
    loadMore: 'Mehr laden',
    chooseAsset: 'Vermögenswert auswählen, um Informationen anzuzeigen',
    chooseAssetMessage: 'Wählen Sie einen Markt aus der Liste links aus, um hier detaillierte Preis- und Projektinformationen zu sehen.',
    sortSymbol: 'Symbol',
    sortPrice: 'Preis',
    sort24h: '24h %',
    sortVolume: 'Volumen'
  },
  marketDetails: {
    loading: 'Wird geladen...',
    loadingData: 'Marktdaten werden geladen…',
    unableToLoad: 'Marktdaten konnten nicht geladen werden',
    tryAgain: 'Erneut versuchen',
    last24h: 'Letzte 24 Stunden',
    priceChart: 'Preisdiagramm',
    hoursAgo: 'Vor 24h',
    now: 'Jetzt',
    marketInfo: 'Marktinformationen',
    marketCap: 'Marktkapitalisierung',
    circulatingSupply: 'Umlaufendes Angebot',
    volume24h: 'Volumen 24h',
    projectInfo: 'Projektinformationen',
    marketIdNotProvided: 'Markt-ID nicht angegeben',
    marketNotFound: 'Markt nicht gefunden',
    errorLoading: 'Fehler beim Laden der Marktdaten'
  },
  dashboard: {
    title: 'Dashboard',
    periods: {
      today: 'Heute',
      week: 'Woche',
      month: 'Monat',
      allTime: 'Gesamt'
    },
    loadingData: 'Dashboard-Daten werden geladen…',
    unableToLoad: 'Dashboard konnte nicht geladen werden',
    tryAgain: 'Erneut versuchen',
    totalBalance: 'Gesamtguthaben',
    unrealizedPnl: 'Nicht realisierter PnL',
    realizedPnl: 'Realisierter PnL',
    totalRoi: 'Gesamt-ROI',
    positions: 'Positionen',
    open: 'Offen',
    closed: 'Geschlossen',
    winRate: 'Gewinnrate',
    avgPnlVolume: 'Durchschn. PnL / Volumen',
    avgPnl: 'Durchschn. PnL',
    volume: 'Volumen',
    profitabilityChart: 'Rentabilitätsdiagramm',
    openPositions: 'Offene Positionen',
    positionsHistory: 'Positionsverlauf',
    noOpenPositions: 'Keine offenen Positionen',
    crossMargin: 'Cross-Margin',
    leverage: 'Hebel',
    margin: 'Marge',
    pnlUnrealized: 'PnL (Nicht realisiert)',
    coinHiddenAlert: 'Der Trader hat das Trading-Paar vorübergehend ausgeblendet, um Insider-Trading und unautorisierte Weitergabe von Handelsdetails zu verhindern, bis die Position geschlossen ist.',
    failedToGetUserId: 'Benutzer-ID konnte nicht abgerufen werden',
    failedToGetUserData: 'Benutzerdaten konnten nicht abgerufen werden',
    errorLoadingData: 'Fehler beim Laden der Dashboard-Daten',
    requestTimeout: 'Zeitüberschreitung der Anfrage'
  },
  positionsHistory: {
    title: 'Positionsverlauf',
    loadingHistory: 'Positionsverlauf wird geladen…',
    unableToLoad: 'Positionen konnten nicht geladen werden',
    tryAgain: 'Erneut versuchen',
    noClosedPositions: 'Keine geschlossenen Positionen',
    entryPrice: 'Einstiegspreis',
    exitPrice: 'Ausstiegspreis',
    margin: 'Marge',
    realizedPnl: 'Realisierter PnL',
    leverage: 'Hebel',
    dateOpened: 'Eröffnungsdatum',
    dateClosed: 'Schließungsdatum'
  },
  admin: {
    balanceDetails: {
      title: 'Guthabendetails',
      loading: 'Guthabendaten werden geladen...',
      noData: 'Nicht genügend Daten verfügbar',
      balance: 'Guthaben:',
      availableBalance: '• Verfügbares Guthaben',
      unrealizedProfit: '• Nicht realisierter Gewinn',
      tradingCredit: '• Handelskredit',
      marginUsed: '• Verwendete Marge',
      openPositions: '• Offene Positionen',
      close: 'Schließen',
      edit: 'Bearbeiten',
      cancel: 'Abbrechen',
      save: 'Speichern',
      balanceHint: 'Gesamtguthabenbetrag',
      tradingCreditHint: 'Handelskreditbetrag',
      readonlyNote: 'Die folgenden Felder werden automatisch berechnet:',
      create: 'Guthabendaten erstellen'
    }
  },
  common: {
    days: 'T',
    usdt: 'USDT'
  },
  deposit: {
    title: 'Einzahlung',
    selectToken: 'Token auswählen',
    selectNetwork: 'Netzwerk auswählen',
    connected: 'Verbunden',
    notConnected: 'Nicht verbunden',
    token: 'Token',
    network: 'Netzwerk',
    backToToken: 'Zurück zur Token-Auswahl',
    loadingAddress: 'Einzahlungsadresse wird geladen...',
    noWalletTitle: 'Keine Wallet verbunden',
    noWalletMessage: 'Bitte verbinden Sie Ihre Wallet über die Landing-Page, um Einzahlungen zu erhalten.',
    copyAddress: 'Adresse kopieren',
    copied: 'Kopiert!',
    warning1: 'Senden Sie nur {token} ({network}) an diese Adresse',
    warning2: 'Mindesteinzahlung: {min} USDT',
    warning3: 'Guthaben wird nach Bestätigung automatisch gutgeschrieben',
    warning4: 'Keine Gebühren für Einzahlungen'
  }
}

